import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  CustomError,
  ERROR_MESSAGE_DICTIONARY,
  ErrorStatus,
  EXTERNAL_SERVICE_ERROR_MESSAGE,
  INCORRECT_IDENTITY_ROLE_ERROR_MESSAGE,
  isHttpErrorResponse,
  UNKNOWN_ERROR_MESSAGE,
} from './error-alert.utils';

@Component({
  selector: 'nk-error-alert',
  imports: [TranslateModule],
  templateUrl: './error-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorAlertComponent {
  public error = input<(HttpErrorResponse & CustomError) | undefined>();
  public showOriginalMessage = input(true);
  public andClass = input('');
  public message = computed(() => {
    const error = this.error();
    if (!error) {
      return;
    }
    if (isHttpErrorResponse(error)) {
      if (error.error?.error_key === 'external_service_error') {
        return EXTERNAL_SERVICE_ERROR_MESSAGE;
      } else {
        return ERROR_MESSAGE_DICTIONARY[error.status as ErrorStatus];
      }
    }
    if (error && (error as CustomError).code === 'incorrect_identity_role') {
      return INCORRECT_IDENTITY_ROLE_ERROR_MESSAGE;
    }
    if (error && !this.message) {
      return UNKNOWN_ERROR_MESSAGE;
    }
    return;
  });
  public originalMessage = computed(() => {
    const error = this.error();
    if (this.showOriginalMessage() && isHttpErrorResponse(error)) {
      return error?.error?.message;
    }
    return;
  });
}
